import React from 'react';
import moment from 'moment';

export const PagoExitoso = (data) => {
    console.log(data);
  const {topup_amount,mdn, approval_code} = data;

  const fecha = moment().format('lll');




  return (
    <div className='contenedorTicket'>
        <div className='parte1'>
            <div className='iconoExito'></div>
            <div className='tituloTicket'>¡Pago exitoso!</div>
            
            <div className='cantidadPagada'>${topup_amount}.00</div>
            <p>Tu recarga y tu promoción se verá aplicada en un momento</p>
        </div>
        <div className='parte2'>
            <div className='contNum'>
                <span className='icoCel'></span>
                <span className='textoIco'>{mdn}</span>
            </div>
            <div className='contNum2'>
                <span>Código de aprobación: </span>
                <span >{approval_code}</span>
            </div>
            <div className='contNum2'>
            <span>Fecha: </span>
                <span >{fecha}</span>
            </div>
        </div>
    </div>
  )
}
